import { defineMessages } from "react-intl";

const messages = defineMessages({
    changeCover: {
        id: "test.changeCover",
    },
    select: {
        id: "general.select",
    },
    labeled: {
        id: "planCard.labeled",
    },
    publicationInProgress: {
        id: "planCard.publicationInProgress",
    },
    listed: {
        id: "planCard.listed",
    },
    upload: {
        id: "changePicture.upload",
    },
});

export default messages;
